import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  materia_selected: {}, //seleccionara el objeto de la lista de magistrados
  materias: []
};
export const mutations = {
  SELECT_MATERIA({ context }, materia) {
    return (state.materia_selected = Object.assign({}, materia));
  },
  FILL_MATERIAS({ context }, list_materias) {
    let materias = [];
    Object.entries(list_materias).forEach(([key, val]) =>{
      materias.push(val)
    });
    return (state.materias = materias);
  }
};
export const actions = {
  GET_ALL_MATERIAS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("FILL_MATERIAS", response.data.data.materias);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
};
export const getters = {
  getAllMaterias: state => state.materias,
  getMateriasActivas: state => {
    const activos = state.materias.filter(materias => {
      console.log("materias");
      if (materia.activo) {
        return true;
      }
    });
    // console.log("mis materias activos", activos);
    return activos;
  },
  getMateriaSelected: state => {
    return state.materia_selected;
  }
};
